
import React from "react";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
} from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { UseFormReturn } from "react-hook-form";

interface SermonTypeSelectProps {
  form: UseFormReturn<any>;
}

const sermonTypes = [
  "Expository",
  "Topical",
  "Textual",
  "Narrative",
  "Thematic",
  "Biographical",
  "Historical",
  "Doctrinal",
  "Evangelistic",
  "Pastoral"
];

export function SermonTypeSelect({ form }: SermonTypeSelectProps) {
  return (
    <FormField
      control={form.control}
      name="sermon_type"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Sermon Type</FormLabel>
          <Select
            value={field.value || "Expository"}
            onValueChange={field.onChange}
            defaultValue="Expository"
          >
            <FormControl>
              <SelectTrigger className="focus:ring-2 focus:ring-primary-500 focus:ring-offset-1 ring-offset-background">
                <SelectValue placeholder="Select sermon type" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {sermonTypes.map((type) => (
                <SelectItem key={type} value={type}>
                  {type}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormDescription>
            The style or approach for this sermon
          </FormDescription>
        </FormItem>
      )}
    />
  );
}
